import React from "react"
import "./feature_card.scss"

import Col from "react-bootstrap/Col"
import Button from "react-bootstrap/Button"
import Card from "react-bootstrap/Card"

export default function FeatureCard(props) {
  return (
    <Card className="feature-card">
      <Card.Header>
        <div className="title">{props.title}</div>
        <div className="subtitle">{props.subtitle}</div>
      </Card.Header>
      <Card.Body>{props.description}</Card.Body>
      <Card.Footer className="text-right">
        <Button className="more" href={props.link} target="_blank">
          More &gt;
        </Button>
      </Card.Footer>
    </Card>
  )
}
